import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';

import { MEDIUM_SOY } from 'base/constants/colors';

import { withStyles } from '@material-ui/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const styles = {
  checked: {
    '& .$MuiSvgIcon-root': {
      fill: `${MEDIUM_SOY} !important`
    }
  }
};

class CheckBoxItem extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    checked: PropTypes.bool,
    value: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    classes: PropTypes.object
  };

  handleCheckBoxChange = event => {
    const { onChange } = this.props;
    onChange(event);
  };

  render() {
    const { checked, value, label, disabled, name, classes } = this.props;
    return (
      <FormControlLabel
        control={
          <Checkbox
            name={name}
            value={value}
            label={label}
            disabled={disabled}
            checked={checked}
            onChange={this.handleCheckBoxChange}
            classes={classes}
          />
        }
        label={label}
      />
    );
  }
}

export default withStyles(styles)(CheckBoxItem);
